module.exports = __webpack_public_path__ + "jtails-build/img/background@2.acc21823.jpg";